export default __webpack_public_path__ + "static/media/Picture2.1163d97f.png";